import styled from 'styled-components';

const LegendContainer = styled.div`
  width: 166px;
  flex: 0 0 166px;
  margin-left: 16px;
`;

export { LegendContainer };
